/* eslint-disable max-classes-per-file */
export class RequestError extends Error {
  public constructor(public status: number, message?: string) {
    super(message)
  }
}

export class ParseError extends Error {}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ensureError = (err: Error | string | any): Error => {
  if (err instanceof Error) {
    return err
  }
  if (typeof err === "string") {
    return new Error(err)
  }
  return new Error("Unknown error")
}

export const createParseError = (json: string, error: Error): ParseError => {
  const parseError = new ParseError(`${error.message} with "${json}"`)
  parseError.name = "ParseError"
  return parseError
}

export const createRequestError = (response: Response): RequestError => {
  const requestError = new RequestError(response.status)
  requestError.name = "RequestError"
  return requestError
}

export const handleFetchError = (endpoint: string, context?: object) => (error: Error) => {
  if (error instanceof RequestError) {
    throw new Error(
      `${error.name} occurred when fetching endpoint "${endpoint}": ${error.status}${
        context ? ` (${JSON.stringify(context)})` : ""
      }`
    )
  } else {
    throw new Error(
      `${error.name} occurred when fetching endpoint "${endpoint}": ${error.message}${
        context ? ` (${JSON.stringify(context)})` : ""
      }`
    )
  }
}
